import { DamagedMaterialsProvider } from 'Context/RocketScan';
import { DamagedMaterials } from 'Containers/RocketScan';
import React, { memo } from 'react';
import { areEqual } from 'Utils/equalityChecks';
import { DamageMaterial, SelectedItem } from 'Containers/RocketScope/types';

interface Props {
  roomId: number;
  projectId: number;
  locationId: number;
  roomDamagedMaterials: DamageMaterial[];
  roomScopeOfWorkItems: SelectedItem[];
}

const DamagedMaterialsWrapper = ({
  roomId,
  projectId,
  locationId,
  roomDamagedMaterials,
  roomScopeOfWorkItems,
}: Props) => (
  <DamagedMaterialsProvider
    roomId={roomId}
    projectId={projectId}
    locationId={locationId}
    roomDamagedMaterials={roomDamagedMaterials}
    roomScopeOfWorkItems={roomScopeOfWorkItems}
  >
    <DamagedMaterials />
  </DamagedMaterialsProvider>
);

const DamagedMaterialsWrapperMemo = memo(DamagedMaterialsWrapper, areEqual);

export { DamagedMaterialsWrapperMemo as DamagedMaterialsWrapper };
